<script setup lang="ts">
import { ref, computed } from 'vue';

const props = defineProps<{
  item: any;
  isWaterfall?: boolean;
}>();

const videoLoaded = ref(false);
const imageLoaded = ref(false);

// const onVideoCanPlay = () => {
//   videoLoaded.value = true;
// };

// const onImageLoad = () => {
//   imageLoaded.value = true;
// };

// 瀑布流模式在媒体未加载前用 aspect-ratio 占位，避免布局抖动
const mediaStyle = computed(() => ({
  aspectRatio:
    props.isWaterfall && !imageLoaded.value && !videoLoaded.value
      ? '375 / 494'
      : 'auto'
}));
</script>

<template>
  <!-- 关键：h-full 让卡片高度跟随父容器（CommonWaterfall 的 fixedHeight） -->
  <div class="lab-card-content bg-white rounded-[14px] shadow-sm overflow-hidden group relative flex-col cursor-pointer h-full padding-[14px] " :style="{background: item.mobile_card_bgC}">
    <div class="text absolute font-[600] text-[14px] bottom-[14px] left-[14px] text-[#fff]">{{ item.title }}</div>
    <img :src="item.mobile_card_icon" :alt="item.title" class="icon absolute max-w-[38px] max-h-[38px] right-[14px] top-[14px]">
  </div>
</template>

<style scoped>
.lab-card-content {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.lab-card-content:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
</style>

